import * as CryptoJS from 'crypto-js';
import { pki, md, util } from 'node-forge';
import { environment } from 'src/environments/environment';

const SHARED_SECRET = environment.frontendSignatureSecret || 'h8Fk2!pL9zXw4@mN7qVb';

/**
 * Utilidad de criptografía para firmar peticiones de forma segura.
 */
export class CryptoUtil {

  /**
   * Genera una cadena aleatoria de 32 bytes (64 caracteres hex)
   * Sirve como llave única para la firma de cada petición.
   */
  static generateRandomKey(): string {
    return CryptoJS.lib.WordArray.random(32).toString(CryptoJS.enc.Hex);
  }

  /**
   * Encripta la llave única (AES/HMAC key) usando la llave pública RSA del servidor.
   */
  static encryptKeyWithRSA(aesKey: string, publicKeyPem: string): string {
    try {
      const publicKey = pki.publicKeyFromPem(publicKeyPem);
      const encrypted = publicKey.encrypt(aesKey, 'RSA-OAEP', {
        md: md.sha256.create()
      });
      return util.encode64(encrypted);
    } catch (error) {
      console.error('Error encriptando llave con RSA', error);
      throw error;
    }
  }

  /**
   * Genera el Hash de la petición y lo ENCRIPTA usando AES con la llave única.
   */
  static generateSignature(
    aesKeyHex: string,
    url: string,
    timestamp: string,
    method: string,
    bodyText: string
  ): string {
    // 1. Crear la sopa de datos
    const dataToSign = `${method.toUpperCase()}|${url}|${timestamp}|${bodyText}|${SHARED_SECRET}`;

    // 2. Generar el Hash puro (SHA256)
    const hash = CryptoJS.SHA256(dataToSign).toString(CryptoJS.enc.Hex);

    // 3. Encriptar el Hash usando AES (Ocultarlo)
    const keyParsed = CryptoJS.enc.Hex.parse(aesKeyHex);
    const aesEncrypted = CryptoJS.AES.encrypt(hash, keyParsed, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });

    // 4. Retornar el Hash encriptado en formato Base64 (CryptoJS lo retorna en base64 por defecto con toString)
    return aesEncrypted.toString();
  }
}
